module.exports = __webpack_public_path__ + "img/44400.ab5ada25.jpg";